import React, { useEffect } from 'react';
import ArchetypeQuiz from './ArchetypeQuiz';
import { useArchetype } from '../../contexts/ArchetypeContext';

const ArchetypeModal = ({ isOpen, onClose }) => {
    const { showQuiz, closeQuiz, hasArchetype, loading } = useArchetype();

    // Prevenir scroll del body cuando el modal está abierto
    useEffect(() => {
        if (showQuiz) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showQuiz]);

    const handleQuizComplete = (result) => {
        // El contexto se actualizará automáticamente
        closeQuiz();
        onClose();
        // Forzar un refresco para asegurar que se actualiza la redirección
        window.location.reload();
    };

    // Si se debe mostrar el cuestionario automáticamente
    if (showQuiz) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50" />
                <div className="relative w-full h-full md:h-auto md:w-auto md:max-w-4xl md:mx-4">
                    <div className="h-full w-full bg-white md:rounded-lg overflow-hidden flex flex-col">
                        <ArchetypeQuiz
                            onComplete={handleQuizComplete}
                        />
                    </div>
                </div>
            </div>
        );
    }

    // Si no está abierto o el usuario ya tiene arquetipo, no renderizar nada
    if (!isOpen || hasArchetype || loading) {
        return null;
    }

    // Mostrar el dashboard del arquetipo (solo para casos específicos)
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-50" />
            <div className="relative w-full h-full md:h-auto md:w-auto md:max-w-4xl md:mx-4">
                <div className="h-full w-full bg-white md:rounded-lg overflow-hidden flex flex-col">
                    {/* Header sin botón de cierre */}
                    <div className="flex justify-between items-center p-4 md:p-6 border-b">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">
                            Tu Perfil de Negocio
                        </h2>
                    </div>

                    {/* Content - Contenedor con scroll interno si es necesario */}
                    <div className="flex-1 overflow-y-auto p-4 md:p-6">
                        {/* Content - OCULTO (solo para uso interno) */}
                        {/* <ArchetypeDashboard
                            archetype={archetype}
                            onOpenQuiz={handleOpenQuiz}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArchetypeModal; 